import * as React from "react";
import PropTypes from "prop-types";
import { PrimaryButton } from "@fluentui/react/lib/Button";
import Layout from "./Layout";
import { Link } from "@fluentui/react";
import Error from "./Error";

export default function SignedOutView({ onSignIn, signInError }) {
  return (
    <Layout
      header={
        <div className="splash__header">
          <img src={require("./../../../assets/xm-logo.png")} />
        </div>
      }
      content={
        <div className="signin__content">
          <PrimaryButton text="Sign in to XMReality" onClick={onSignIn} />
          <Error error={signInError} />
          <p className="ms-fontSize-12 ms-fontColor-neutralSecondary ms-textAlignCenter">Sign in to add XMReality links to meetings</p>
        </div>
      }
      footer={
        <Link className="ms-fontSize-16" href="https://xmreality.com" underline={false}>
          xmreality.com
        </Link>
      }
    />
  );
}

SignedOutView.propTypes = {
  onSignIn: PropTypes.func.isRequired,
};
